import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export type CopierStatus = 'running' | 'paused' | 'deleted'

// 봇 요약. 백엔드는 목록(admin/copy/copiers)에서만 채워 보낸다.
// 리더 디테일의 copiers[]는 bot_score만, 카피어 디테일(admin/copy/copier/:id)은 둘 다 비어 온다.
export interface ICopierBot {
    id: string
    key_id: string
    name: string
    type: string
    copy_key_id: string
    balance: number
    profit: number
    earning: number
    initial_balance: number
    deposit: number
    withdraw: number
    start_at: number
    status: string
    reason?: string
}

export interface ICopierBotScore {
    score: number
    earning: number
}

// admin/copy/copiers, admin/copy/leader/:id 의 copiers[], admin/copy/copier/:id 가 공유하는 행 구조.
export interface ICopierRow {
    id: string // bot id — 카피어 디테일 경로에 쓰는 값
    user_id: string
    name: string
    exchange: string
    status: CopierStatus
    current_balance: number
    copying_key_id: string // 리더 키 id
    start_at: number // unix 초
    pause_at?: string | null // RFC3339 문자열
    created_at: number // unix 초
    user_name: string
    user_thumbnail: string
    leader_id: string
    leader_name: string
    leader_thumbnail: string
    leader_exchange: string
    bot?: ICopierBot
    bot_score?: ICopierBotScore
}

// filter_status: '' (삭제 제외 전체) | 'running' | 'paused' | 'deleted'(소프트 삭제만)
// sort_by: 'created_at'(기본) | 'earning' | 'balance' | 'profit'
export const getCopiersList = async (
    size: number,
    current_page: number = 1,
    filter_status: string = '',
    exchange: string = '',
    sortBy: string = 'created_at',
): Promise<ApiRes<ICopierRow[]>> => {
    return await apiGet(
        API_URL,
        `admin/copy/copiers?page_size=${size}&current_page=${current_page}&filter_status=${filter_status}&filter_exchange=${exchange}&sort_by=${sortBy}`,
    )
}
